import React from "react";

function ConfiramationPopup({ setOpenPopup, handleSubmit }) {
    return <div className=" delete_query_transprant_body ">
        <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_query_container shadow">
            <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
                <span className="mt-2 mb-5 delete_query_text">
                    Are you sure you want to submit activity?
                </span>
                <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
                    <button
                        className="activebutton btn btn-danger col-sm-5 query_delete_btn"
                        onClick={handleSubmit}
                    >
                        Yes
                    </button>
                    <button
                        className="activebutton btn btn-danger col-sm-5 query_delete_btn default_deleteq_uery_no"
                        onClick={(e) => setOpenPopup(false)}
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    </div>
}

export default ConfiramationPopup;
